export const DOWNLOAD_CSV_TITLE = "si.my-lists.section.enrichment.modal.downloading.title";
export const DOWNLOAD_CSV_HELP = "si.my-lists.section.enrichment.modal.downloading.help";
export const DOWNLOAD_CSV_PRO_ITEM_1 = "si.my-lists.section.enrichment.modal.downloading.help.item_1";
export const DOWNLOAD_CSV_PRO_ITEM_2 = "si.my-lists.section.enrichment.modal.downloading.help.item_2";
export const DOWNLOAD_CSV_PRO_ITEM_3 = "si.my-lists.section.enrichment.modal.downloading.help.item_3";

export const SAVE = "si.my-lists.section.enrichment.modal.downloading.save";
export const NO_INSIGHTS = "si.my-lists.section.enrichment.modal.downloading.cancel";

export const LOADING_TOAST = "si.my-lists.section.enrichment.modal.downloading.loading.toast";
export const ERROR_TOAST = "si.my-lists.section.enrichment.modal.downloading.error.toast";
export const SUCCESS_TOAST = "si.my-lists.section.enrichment.modal.downloading.success.toast";
